dayjs.extend(window.dayjs_plugin_utc);
dayjs.extend(window.dayjs_plugin_timezone);

function countDown(deliveryDays, noDeliveryDates, orderBeforeHours, localization, currentTimezone, locationTimezone, neverDeliverOn){
  // Clear the interval if it exists
  window.intervalId ? clearInterval(window.intervalId) : console.log('clear interval');

  if (locationTimezone === 'undefined' || locationTimezone === '' || locationTimezone === null) {
    locationTimezone = currentTimezone;
  }

  // Get the delivery time element
  const expectedDeliveryTime = document.querySelector('.product-delivery-time');
  if (!expectedDeliveryTime) {
    return;
  }
  // Get the delivery time and date text elements
  const deliveryTime = expectedDeliveryTime.querySelector('[data-delivery-time]');
  const deliveryDate = expectedDeliveryTime.querySelector('[data-delivery-date]');

  // Set the delivery date
  var DeliveryDate = new Date();
  DeliveryDate.setDate(DeliveryDate.getDate() + deliveryDays);

  // Check if there are week days that are not available for delivery
  let neverDeliverOnStr = neverDeliverOn.split(',');
  for (let i = 0; i < neverDeliverOnStr.length; i++) {
    const dontDeliverDay = neverDeliverOnStr[i];
    if (DeliveryDate.toLocaleString('en', { weekday: 'long' }) === dontDeliverDay) {
      DeliveryDate.setDate(DeliveryDate.getDate() + 1);
    }
    //check if the new delivery date is a no delivery date
    let noDeliveryDatesStr = noDeliveryDates.split(',');
    for (let i = 0; i < noDeliveryDatesStr.length; i++) {
      const noDate = new Date(noDeliveryDatesStr[i]);
      if (DeliveryDate.toDateString() === noDate.toDateString()) {
        DeliveryDate.setDate(DeliveryDate.getDate() + 1);
      }
    }
  }

  // When there are no weekdays excluded from delivery, check if the delivery date is a no delivery date
  if (neverDeliverOnStr === '' || neverDeliverOnStr === null || neverDeliverOnStr === 'undefined') {
    let noDeliveryDatesStr = noDeliveryDates.split(',');
    for (let i = 0; i < noDeliveryDatesStr.length; i++) {
      const noDate = new Date(noDeliveryDatesStr[i]);
      if (DeliveryDate.toDateString() === noDate.toDateString()) {
        DeliveryDate.setDate(DeliveryDate.getDate() + 1);
      }
    }
  }

  // Format the delivery date
  const newMonth = DeliveryDate.toLocaleString(localization, { month: 'long' });
  const newWeekday= DeliveryDate.toLocaleString(localization, { weekday: 'long' });
  const newDay = DeliveryDate.toLocaleString(localization, { day: 'numeric' });
  const newYear = DeliveryDate.toLocaleString(localization, { year: 'numeric' });

  deliveryDate.textContent = newWeekday + ' ' + newDay + ' ' + newMonth + ', ' + newYear + '.';

  // Set the date we're counting down to
  let currTimezone = dayjs.tz(new Date(), currentTimezone);
  let locTimeZone = dayjs.tz(new Date(), locationTimezone);
  const diff = Math.abs(currTimezone - locTimeZone);
  var countDownTime = dayjs(countDownTime).hour(orderBeforeHours);

  countDownTime = dayjs(countDownTime).minute(0);
  countDownTime = dayjs(countDownTime).second(0);
  countDownTime = dayjs(countDownTime).millisecond(0);

  // Update the count down every 1 second
  var x = setInterval(function() {
    const now = dayjs.tz(new Date(), locationTimezone);
    var distance = countDownTime - now;

    // If the count down is finished, write some text
    if (distance < 0) {

      // add a day when the delivery date is expired and start counting down again
      DeliveryDate.setDate(DeliveryDate.getDate() + 1);
      const newMonth = DeliveryDate.toLocaleString(localization, { month: 'long' });
      const newWeekday = DeliveryDate.toLocaleString(localization, { weekday: 'long' });
      const newDay = DeliveryDate.toLocaleString(localization, { day: 'numeric' });
      const newYear = DeliveryDate.toLocaleString(localization, { year: 'numeric' });

      deliveryDate.textContent = newWeekday + ' ' + newDay + ' ' + newMonth + ', ' + newYear + '.';

      // set new countDownTime
      countDownTime = dayjs(countDownTime).add(1, 'days');

      distance = countDownTime - now;
    }

    // Time calculations for days, hours, minutes and seconds
    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);

    // Display the result
    deliveryTime.textContent = hours + "h " + minutes + "m " + seconds + "s";

    expectedDeliveryTime.style.display = 'flex';
  }, 1000);

  window.intervalId = x;

}


const expectedDeliveryTime = document.querySelector('.product-delivery-time');
if (expectedDeliveryTime) {
  const locationSelect = expectedDeliveryTime.querySelector('select[name="location"]');
  locationSelect.addEventListener('change', function() {

    setTimeout(() => {
      countDown(window.ipLocation.deliveryDays, window.ipLocation.noDeliveryDates, window.ipLocation.orderBeforeHours, window.ipLocation.localization, window.ipLocation.currentTimezone, window.ipLocation.locationTimezone, window.ipLocation.neverDeliverOn);
    }, 200);
  });
}
// Set a timeout to wait for the ipLocation object to be available
setTimeout(() => {
  countDown(window.ipLocation.deliveryDays, window.ipLocation.noDeliveryDates, window.ipLocation.orderBeforeHours, window.ipLocation.localization, window.ipLocation.currentTimezone, window.ipLocation.locationTimezone, window.ipLocation.neverDeliverOn);
}, 200);